import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './circleImageTitle.css';
import { Icon } from './../../../ui/src/component/icon';

const CircleImageTitle = props => {
  return (
    <div
      className={cx('clearfix', 'circle-image-title', {
        active: props.active,
        playable: props.playable,
      })}
    >
      <div className="img">
        <div
          className="thumb"
          style={{ backgroundImage: 'url(' + props.image + ')' }}
        >
          {props.playable && (
            <div className="play">
              <Icon name="play" />
            </div>
          )}
        </div>
      </div>
      <div className="content">
        <div className="title">{props.title}</div>
        <div className="subtitle">{props.subtitle}</div>
      </div>
      <div className="time">{props.time}</div>
    </div>
  );
};

CircleImageTitle.defaultProps = {
  subtitle: null,
  time: null,
  active: false,
  onClick: null,
  playable: false,
};

CircleImageTitle.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  time: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  playable: PropTypes.bool,
};

export default CircleImageTitle;



// WEBPACK FOOTER //
// ./src/app/component/circleImageTitle/circleImageTitle.js